.sidebar {
	position: fixed;
	left: 0;
	top: 8.5vh;
	height: calc(100vh - 8.5vh);
	background-color: #7fb02f;
	display: flex;
	flex-direction: column;
	transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	z-index: 99;
	border-right: 1px solid #6d9728;

	&.collapsed {
		width: 64px;
		overflow: visible;
	}

	&.expanded {
		width: 240px;
		overflow: hidden;
	}
}

.sidebarContent {
	display: flex;
	flex-direction: column;
	padding: 1rem 0;
	gap: 0.25rem;
	flex: 1;
	height: 100%;

	&::-webkit-scrollbar {
		width: 4px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}

	&::-webkit-scrollbar-thumb {
		background: #6d9728;
		border-radius: 2px;

		&:hover {
			background: #5d811f;
		}
	}
}

.expanded .sidebarContent {
	overflow-y: auto;
	overflow-x: hidden;
}

.collapsed .sidebarContent {
	overflow: visible;
}

.menuGroup {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
}

.expanded .menuGroup {
	position: static;
}

.collapsed .menuGroup {
	position: relative;
	overflow: visible;
}

.menuItem {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	padding: 0.75rem 1rem;
	margin: 0 0.5rem;
	background: transparent;
	border: none;
	border-radius: 8px;
	color: rgba(255, 255, 255, 0.9);
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: normal;
	word-wrap: break-word;
	position: relative;
	text-align: left;
	width: calc(100% - 1rem);
	min-height: 44px;

	svg {
		flex-shrink: 0;
		stroke: rgba(255, 255, 255, 0.9);
		transition: stroke 0.2s ease;
	}

	&:hover {
		background-color: rgba(0, 0, 0, 0.15);
		color: #ffffff;

		svg {
			stroke: #ffffff;
		}
	}

	&.active {
		background-color: rgba(0, 0, 0, 0.25);
		color: #ffffff;

		svg {
			stroke: #ffffff;
		}

		&:hover {
			background-color: rgba(0, 0, 0, 0.3);
		}
	}

	.collapsed & {
		justify-content: center;
		padding: 0.75rem;
		white-space: nowrap;

		&::after {
			content: attr(title);
			position: absolute;
			left: 100%;
			margin-left: 0.75rem;
			padding: 0.5rem 0.75rem;
			background-color: #1a1a1a;
			color: #ffffff;
			border-radius: 6px;
			font-size: 13px;
			white-space: nowrap;
			opacity: 0;
			pointer-events: none;
			transition: opacity 0.2s ease;
			z-index: 1000;
			box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);
		}

		&:hover::after {
			opacity: 1;
		}
	}
}

.menuLabel {
	flex: 1;
	line-height: 1.4;
	word-break: break-word;
}

.submenuContainer {
	display: none;
	flex-direction: column;
	gap: 0.125rem;
	padding-left: 2.5rem;
	margin-top: 0.25rem;

	&.submenuExpanded {
		display: flex;
	}
}

.collapsed .submenuContainer {
	display: none;
	position: fixed;
	left: 64px;
	padding: 0.5rem;
	background-color: #1a1a1a;
	border-radius: 8px;
	box-shadow:
		0 10px 15px -3px rgba(0, 0, 0, 0.5),
		0 4px 6px -2px rgba(0, 0, 0, 0.3);
	min-width: 200px;
	max-width: 280px;
	max-height: calc(100vh - 100px);
	overflow-y: auto;
	overflow-x: hidden;
	z-index: 10000;

	&::-webkit-scrollbar {
		width: 4px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}

	&::-webkit-scrollbar-thumb {
		background: #404040;
		border-radius: 2px;

		&:hover {
			background: #525252;
		}
	}
}

.collapsed .submenuContainer.submenuPinned {
	display: flex !important;
}

.submenuItem {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	padding: 0.5rem 1rem;
	background: transparent;
	border: none;
	border-radius: 6px;
	color: rgba(255, 255, 255, 0.8);
	font-size: 14px;
	font-weight: 400;
	cursor: pointer;
	transition: all 0.2s ease;
	text-align: left;
	white-space: normal;
	word-wrap: break-word;
	width: 100%;
	line-height: 1.4;

	svg {
		flex-shrink: 0;
		stroke: rgba(255, 255, 255, 0.8);
		transition: stroke 0.2s ease;
	}

	span {
		flex: 1;
		word-break: break-word;
	}

	&:hover {
		background-color: rgba(0, 0, 0, 0.15);
		color: #ffffff;

		svg {
			stroke: #ffffff;
		}
	}

	&.active {
		background-color: rgba(0, 0, 0, 0.25);
		color: #ffffff;
		font-weight: 500;

		svg {
			stroke: #ffffff;
		}

		&:hover {
			background-color: rgba(0, 0, 0, 0.3);
		}
	}

	.expanded & {
		justify-content: flex-start;
	}

	.collapsed & {
		justify-content: flex-start;
		padding: 0.5rem 0.75rem;
		width: 100%;
		color: rgba(255, 255, 255, 0.9);

		svg {
			stroke: rgba(255, 255, 255, 0.9);
		}
	}
}

@media (max-width: 768px) {
	.sidebar {
		top: 0;
		height: 100vh;
		z-index: 100;

		&.collapsed {
			width: 0;
			border-right: none;
			overflow: hidden;
			pointer-events: none;
		}

		&.collapsed .sidebarContent,
		&.collapsed .menuGroup,
		&.collapsed .menuItem,
		&.collapsed .submenuContainer {
			display: none !important;
		}

		&.expanded {
			width: 100%;
			max-width: 300px;
			box-shadow: 0 12px 32px rgba(15, 23, 42, 0.25);
		}

		&.expanded .sidebarContent {
			padding-top: 1.25rem;
		}

		&.expanded .menuItem {
			font-size: 16px;
			padding: 0.95rem 1.1rem;
			min-height: 52px;
			gap: 1rem;

			svg {
				width: 24px;
				height: 24px;
			}
		}

		&.expanded .submenuItem {
			font-size: 15px;
			padding: 0.7rem 1rem;
			min-height: 44px;

			svg {
				width: 20px;
				height: 20px;
			}
		}
	}
}

.mobileBackdrop {
	display: none;
	position: fixed;
	inset: 0;
	background: rgba(15, 23, 42, 0.45);
	border: 0;
	padding: 0;
	z-index: 98;
	cursor: pointer;
}

@media (max-width: 768px) {
	.mobileBackdrop {
		display: block;
		z-index: 99;
	}
}
